import NavigationScrollHandler from './utils/_navigation-scroll'
import { debounce } from 'lodash'

/* global jQuery */

document.addEventListener('DOMContentLoaded', () => {
  const navigation = new Navigation()
  navigation.init()
})

class Navigation {
  constructor () {
    this.HEADER = document.querySelector('.mt-header')
    if (!this.HEADER) {
      return
    }

    this.NAV_TOGGLE = this.HEADER.querySelector('.navigation-toggle')
    this.SEARCH_BUTTONS = this.HEADER.querySelectorAll('.mt-header__search-button')
    this.ARROWS = this.HEADER.querySelectorAll('.dropdown-arrow')
    this.NAV_OVERLAY = document.getElementById('header-overlay')
    this.FULL_OVERLAY = document.getElementById('full-overlay')
    this.SEARCH_POPUP = document.querySelector('.mt-search-popup')
    this.SEARCH_INPUT = document.querySelector('.mt-search-popup__input')

    this.breakPoint = 1160
    this.screenSize = this.getScreenWidth()
    this.canToggle = true
  }

  init () {
    this.eventHandlers()

    const scrollHandler = new NavigationScrollHandler({
      scrollDistance: 60,
      headerElement: this.HEADER,
      onEnter: () => {
        this.HEADER.classList.add('mt-header--scrolled')
      },
      onExit: () => {
        this.HEADER.classList.remove('mt-header--scrolled')
      }
    })
  }

  eventHandlers ()  {
    this.NAV_TOGGLE && this.NAV_TOGGLE.addEventListener('click', () => this.toggleNavigation())
    this.NAV_OVERLAY.addEventListener('click', () => this.closeNavigation())
    this.FULL_OVERLAY.addEventListener('click', () => this.closeNavigation())

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closeNavigation()
      }
    })

    window.addEventListener('resize', debounce(() => {
      if (this.screenSize !== this.getScreenWidth()) {
        this.closeNavigation()
      }
      this.screenSize = this.getScreenWidth()
    }, 300))

    if (this.ARROWS.length > 0) {
      this.ARROWS.forEach((ARROW) => {
        ARROW.addEventListener('click', () => {
          ARROW.parentElement.classList.toggle('menu-item-open')
          jQuery(ARROW.nextElementSibling).slideToggle(300)
        })
      })
    }

    if (this.SEARCH_BUTTONS.length > 0) {
      this.SEARCH_BUTTONS.forEach((SEARCH_BUTTON) => {
        SEARCH_BUTTON.addEventListener('click', () => {
          this.SEARCH_POPUP.classList.toggle('mt-search-popup--open')
          this.FULL_OVERLAY.classList.toggle('mt-overlay--show')
          setTimeout(() => {
            this.SEARCH_INPUT.focus()
          }, 50)
        })
      })
    }
  }

  toggleNavigation () {
    this.toggleable()

    this.HEADER.classList.toggle('mt-header--open')
    this.NAV_TOGGLE.classList.toggle('open')
    this.NAV_OVERLAY.classList.toggle('mt-overlay--show')
    document.body.classList.toggle('header-open')
  }

  closeNavigation () {
    if(this.SEARCH_POPUP.classList.contains('mt-search-popup--open')){
      this.SEARCH_POPUP.classList.remove('mt-search-popup--open')
    }
    this.HEADER.classList.remove('mt-header--open')
    this.NAV_TOGGLE.classList.remove('open')
    this.NAV_OVERLAY.classList.remove('mt-overlay--show')
    this.FULL_OVERLAY.classList.remove('mt-overlay--show')
    document.body.classList.remove('header-open')
  }

  toggleable () {
    if (!this.canToggle) return
    this.canToggle = false
    setTimeout(() => { this.canToggle = true }, 500)
  }



  getScreenWidth () {
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
  }
}
